module.exports = __webpack_public_path__ + "static/media/cancel.efeade5e.svg";